import React, { useState, useEffect } from "react";
import Button from "../form/Button";
import Input from "../form/Input";
import { postData } from "../../services/api";
import { useTranslation } from "react-i18next";
import toastr from "toastr";
import { MAIN_LOGO } from "../../constant/Constant";

const EmergencyReplacementPlanContent = ({ data }) => {
  const { t } = useTranslation();
  const [details, setDetails] = useState([]);
  const [email, setEmail] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [cellPhone, setCellPhone] = useState("");
  const [viceChair, setViceChair] = useState("");
  const [secretary, setSecretary] = useState("");
  const [treasurer, setTreasurer] = useState("");
  const [rfp, setRfp] = useState("");
  const [rfp2, setRfp2] = useState("");
  const [rfp3, setRfp3] = useState("");
  const [isSave, setIsSave] = useState(false);
  const [isCancel, setIsCancel] = useState(false);

  useEffect(() => {
    async function loadDetails() {
      try {
        const result = await postData("emergency-replace/details", {});
        if (result.data) {
          setDetails(result.data);
        } else {
          console.log("Details message", result.message);
        }
      } catch (error) {
        console.log("Error details catch", error.message);
      }
    }
    loadDetails();
  }, []);

  useEffect(() => {
    setEmail(details?.email);
    setBusinessPhone(details?.business_phone);
    setCellPhone(details?.cell_phone);
    setViceChair(details?.vice_chair);
    setSecretary(details?.secretary);
    setTreasurer(details?.treasurer);
    setRfp(details?.request_for_proposal);
    setRfp2(details?.request_for_proposal_two);
    setRfp3(details?.request_for_proposal_three);
  }, [details]);

  const onCancel = async (e) => {
    setIsCancel(true);
    if (details) {
      setEmail(details?.email);
      setBusinessPhone(details?.business_phone);
      setCellPhone(details?.cell_phone);
      setViceChair(details?.vice_chair);
      setSecretary(details?.secretary);
      setTreasurer(details?.treasurer);
      setRfp(details?.request_for_proposal);
      setRfp2(details?.request_for_proposal_two);
      setRfp3(details?.request_for_proposal_three);
    } else {
      setEmail("");
      setBusinessPhone("");
      setCellPhone("");
      setViceChair("");
      setSecretary("");
      setTreasurer("");
      setRfp("");
      setRfp2("");
      setRfp3("");
    }
    setIsCancel(false);
  };

  const onSave = async (e) => {
    setIsSave(true);
    if (
      email ||
      businessPhone ||
      cellPhone ||
      viceChair ||
      secretary ||
      treasurer ||
      rfp ||
      rfp2 ||
      rfp3
    ) {
      try {
        const result = await postData("emergency-replace/update", {
          email: email,
          business_phone: businessPhone,
          cell_phone: cellPhone,
          vice_chair: viceChair,
          secretary: secretary,
          treasurer: treasurer,
          request_for_proposal: rfp,
          request_for_proposal_two: rfp2,
          request_for_proposal_three: rfp3,
        });
        if (result.status && result.status === 200) {
          toastr.success(result.message);
          setIsSave(false);
        } else {
          toastr.error(result.message);
          setIsSave(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsSave(false);
      }
    } else {
      toastr.error(t("no_data_found"));
      setIsSave(false);
    }
  };

  return (
    <>
      <div className="py-5 sm:py-10 px-4 sm:px-10 lg:px-20 text-base text-black relative w-full max-w-5xl mx-auto  shadow rounded-lg">
        <div className="flex items-center mb-10">
          <div className="w-full h-12 sm:h-16 min-w-[40px]">
            <img
              className="w-full h-full object-contain"
              src={MAIN_LOGO}
              alt={"Logo"}
            />
          </div>
        </div>
        <div className="font-bold text-lg sm:text-2xl mb-6 text-slate-500">
          <h3>
            Emergency/Interim Replacement Policy &amp; Plan – President/CEO
          </h3>
        </div>
        <div className="mb-3 pl-3 text-sm !leading-snug sm:!leading-normal text-slate-500">
          <ul className="list-decimal list-outside marker:font-semibold space-y-10">
            <li className="pl-3 sm:pl-2">
              <div className="space-y-3 mb-5">
                <p className="whitespace-pre-wrap">
                  <span className="font-semibold underline">
                    Involuntary termination:
                  </span>{" "}
                  {data?.involuntary_termination}
                </p>
              </div>
              <div className="pl-4">
                <ul className="list-disc list-outside space-y-2 sm:space-y-0">
                  <li>
                    <div className="flex items-center space-x-4 mb-3">
                      <div className="relative w-full ">
                        {" "}
                        <Input
                          inputType={"text"}
                          inputPlaceholder={t("enter_email")}
                          inputValue={email}
                          setInput={setEmail}
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center space-x-4 mb-3">
                      <div className="relative w-full">
                        {" "}
                        <Input
                          inputType={"text"}
                          inputPlaceholder={t("enter_business_phone")}
                          inputValue={businessPhone}
                          setInput={setBusinessPhone}
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center space-x-4">
                      <div className="relative w-full">
                        {" "}
                        <Input
                          inputType={"text"}
                          inputPlaceholder={t("enter_cell_phone")}
                          inputValue={cellPhone}
                          setInput={setCellPhone}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li className="pl-3 sm:pl-2">
              <div className="space-y-3 mb-5">
                <p className="whitespace-pre-wrap">
                  <span className="font-semibold underline">
                    Voluntary termination:
                  </span>{" "}
                  {data?.voluntary_termination}
                </p>
                {data.voluntary_ermination_options?.length > 0 &&
                  data.voluntary_ermination_options.map((row, key) => (
                    <div key={key}>
                      <p className="whitespace-pre-wrap mb-2">
                        {row.title && <span className="font-semibold underline">{row.title}:</span>}{" "}
                        {row.description || ""}
                      </p>

                      {key === 0 && (
                        <div className="pl-4 mb-2">
                          <ul className="list-decimal list-outside marker:font-normal">
                            <li>
                              <div className="flex items-center space-x-4 mb-3">
                                <div className="relative w-full">
                                  <Input
                                    inputType="text"
                                    inputPlaceholder={t("enter_vice_chairman")}
                                    inputValue={viceChair}
                                    setInput={setViceChair}
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="flex items-center space-x-4 mb-3">
                                <div className="relative w-full">
                                  <Input
                                    inputType="text"
                                    inputPlaceholder={t("enter_secretary")}
                                    inputValue={secretary}
                                    setInput={setSecretary}
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="flex items-center space-x-4 mb-3">
                                <div className="relative w-full">
                                  <Input
                                    inputType="text"
                                    inputPlaceholder={t("enter_treasurer")}
                                    inputValue={treasurer}
                                    setInput={setTreasurer}
                                  />
                                </div>
                              </div>
                            </li>
                            <li>or the Supervisory Committee of the Board.</li>
                          </ul>
                        </div>
                      )}
                    </div>
                ))}               
              </div>
            </li>
            <li className="pl-3 sm:pl-2">
              <div className="space-y-3 mb-5">
                <p>
                  <span className="font-semibold underline">Action Plan:</span>
                </p>
                {
                  (data.action_plan && data.action_plan.length>0) && 
                  data.action_plan.map((row2,key2) => (
                    <div key={key2}>
                      <p className="mb-3"><span className="underline">{row2?.title}:</span></p>
                      <div className="shadow overflow-auto rounded-lg mb-10 -ml-6 sm:ml-0">
                        <table className="border-collapse table-auto w-full text-sm !leading-tight sm:!leading-snug">
                          <thead>
                            <tr>
                              <th className="border-b font-medium p-4 text-slate-400 bg-slate-100 text-left">
                                <div>Responsibility</div>
                              </th>
                              <th className="border-b font-medium p-4 text-slate-400 bg-slate-100 text-left sm:min-w-[200px]">
                                <div>Responsible Party</div>
                              </th>
                            </tr>
                          </thead> 
                          <tbody className="bg-white">
                          {
                            (row2.subTitle && row2.subTitle.length>0) && 
                              row2.subTitle.map((_row2,_key2) => (
                                <tr key={_key2}>
                                  <td className="align-top border-b border-slate-100 py-2 sm:py-4 px-2 sm:px-4 text-slate-500">
                                    <div className="flex space-x-1.5 sm:space-x-3">
                                      <div>{Number(_key2+1)}.</div>
                                      <div className="space-y-3" dangerouslySetInnerHTML={{ __html: _row2?.responsibility }}>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="align-top border-b border-l border-slate-100 py-2 sm:py-4 px-2 sm:px-4 text-slate-500 sm:min-w-[200px]">
                                    <div>{_row2?.responsible_party}</div>
                                  </td>
                                </tr>
                              ))
                          }  
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                }                
              </div> 

            </li>
          </ul>
        </div>
      </div>

      <div className="py-5 sm:py-10 px-4 sm:px-10 lg:px-20 text-base text-black relative  w-full max-w-5xl mx-auto mt-10 shadow rounded-lg">
        <div className="flex items-center mb-10">
          <div className="w-full h-12 sm:h-16 min-w-[40px]">
            <img
              className="w-full h-full object-contain"
              src={MAIN_LOGO}
              alt={"Logo"}
            />
          </div>
        </div>
        <div className="font-bold text-lg sm:text-2xl mb-6 text-slate-500">
          <h3>FORM: External Recruitment Plan – President/CEO</h3>
        </div>

        <div className="mb-3 pl-3 text-sm !leading-snug sm:!leading-normal text-slate-500">
          <div className="space-y-3 mb-5">
            <p>{data?.external_recruitment}</p>
            <ul className="list-decimal list-outside marker:font-normal pl-4 space-y-2 sm:space-y-0">
              {
                (data?.external_recruitment_options && data?.external_recruitment_options.length>0) &&
                data?.external_recruitment_options.map((row3,key3) => (
                  <li className="pl-3 sm:pl-2" >
                    <div key={key3} dangerouslySetInnerHTML={{ __html: row3?.title }}></div>
                    {
                      row3.isResponsibility && 
                      <div className="shadow overflow-hidden rounded-lg mt-2 -ml-6 sm:ml-0">
                        <table className="border-collapse table-auto w-full text-sm !leading-tight sm:!leading-snug">
                          <thead>
                            <tr>
                              <th className="border-b font-medium p-4 text-slate-400 bg-slate-100 text-left">
                                <div>Responsibility</div>
                              </th>
                              <th className="border-b font-medium p-4 text-slate-400 bg-slate-100 text-left sm:min-w-[200px]">
                                <div>Responsible Party</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white">
                            {
                              (row3.subTitle && row3.subTitle.length>0) && 
                              row3.subTitle.map((_row3,_key3) => (
                                <tr key={_key3}>
                                  <td className="align-top border-b border-slate-100 py-2 sm:py-4 px-2 sm:px-4 text-slate-500">
                                    <div className="flex space-x-1.5 sm:space-x-3">
                                      <div>{Number(_key3+1)}.</div>
                                      <div className="space-y-3">
                                        <div key={_key3} dangerouslySetInnerHTML={{ __html: _row3?.responsibility }}></div>      
                                        {
                                          _key3 === 1 &&
                                          <ul className="list-decimal list-outside pl-4">
                                            <li className="mb-3">
                                              <Input
                                                inputType={"text"}
                                                inputPlaceholder={""}
                                                inputValue={rfp}
                                                setInput={setRfp}
                                                //inputClasses={"!h-6 !border-transparent !border-b-gray-400 !rounded-none !bg-transparent !px-0"}
                                              />
                                            </li>
                                            <li className="mb-3">
                                              <Input
                                                inputType={"text"}
                                                inputPlaceholder={""}
                                                inputValue={rfp2}
                                                setInput={setRfp2}
                                                //inputClasses={"!h-6 !border-transparent !border-b-gray-400 !rounded-none !bg-transparent !px-0"}
                                              />
                                            </li>
                                            <li className="mb-3">
                                              <Input
                                                inputType={"text"}
                                                inputPlaceholder={""}
                                                inputValue={rfp3}
                                                setInput={setRfp3}
                                                //inputClasses={"!h-6 !border-transparent !border-b-gray-400 !rounded-none !bg-transparent !px-0"}
                                              />
                                            </li>
                                          </ul>
                                        }                                        
                                      </div>
                                    </div>
                                  </td>
                                  <td className="align-top border-b border-l border-slate-100 py-2 sm:py-4 px-2 sm:px-4 text-slate-500 sm:min-w-[200px]">
                                    <div className="space-y-4 whitespace-pre-wrap">
                                      {_row3?.responsible_party}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    }                    
                  </li>
                ))
              }              
            </ul>
          </div>
        </div>
      </div>

      <div className="py-5 sm:py-10 px-4 sm:px-10 lg:px-20 text-base text-black relative  w-full max-w-5xl mx-auto mt-10 shadow rounded-lg">
        <div className="flex items-center mb-10">
          <div className="w-full h-12 sm:h-16 min-w-[40px]">
            <img
              className="w-full h-full object-contain"
              src={MAIN_LOGO}
              alt={"Logo"}
            />
          </div>
        </div>
        <div className="font-bold text-lg sm:text-2xl mb-6 text-slate-500">
          <h3>Guidelines for Selecting a Search Firm*</h3>
        </div>

        <div className="mb-3 sm:pl-3 text-sm !leading-tight sm:!leading-normal text-slate-500">
          <ul className="list-decimal list-outside marker:font-normal pl-4 space-y-3">
          {
            (data.guidelines && data.guidelines.length>0) && 
            data.guidelines.map((row3,key3) => (
               <li className="pl-3 sm:pl-2">{row3}</li>
            ))
          }
          </ul>
        </div>
      </div>

      <div className="px-4 py-2 sm:px-0 sm:py-0 sm:mt-10 text-base text-black relative  w-full max-w-5xl mx-auto">
        <div className="flex justify-end">
          <div className="flex items-center justify-end gap-4">
            <Button
              buttonLabelClasses=""
              buttonType={"button"}
              buttonIcon={
                isCancel ? "fa-light fa-spinner fa-spin" : "fa-light fa-times"
              }
              buttonIconPosition={"left"}
              buttonLabel={t("cancel")}
              buttonClasses={
                "!bg-slate-200 !text-slate-600 border border-slate-300"
              }
              functions={onCancel}
              buttonHasLink={false}
              buttonDisabled={isCancel}
            />
            <Button
              buttonClasses=""
              buttonLabelClasses=""
              buttonType={"button"}
              buttonIcon={
                isSave ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
              }
              buttonIconPosition={"left"}
              buttonLabel={t("save")}
              functions={onSave}
              buttonHasLink={false}
              buttonDisabled={isSave}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmergencyReplacementPlanContent;
